<template>
    <div class="d-flex">
        <div v-for="event in securityEvents" :key="event.id" class="mr-1">
            <v-tooltip color="primary" top max-width="350">
                <template v-slot:activator="{ on }">
                    <v-chip v-on="on" color="red darken-2" label small>
                        <v-icon small left>mdi-flag-variant</v-icon>
                        {{ event.type }}
                    </v-chip>
                </template>
                <span>
                    {{ event.description }}
                </span>
            </v-tooltip>
        </div>
    </div>
</template>

<script>

import Json from 'vue-json-pretty';

export default {

    components: {
        Json
    },

    props: {
        securityEvents: {
            type: Array,
            required: true,
        }
    },
}
</script>
